/** 認証アプリのコードの桁数 */
export const TOTP_CODE_LENGTH = 6;

interface TotpCodeInputProps {
  value: string;
  onChange: (value: string) => void;
}

/**
 * 認証アプリの 6 桁コードの入力欄。数字以外は取り除き、ワンタイムコードの自動入力に対応する。
 */
export function TotpCodeInput({ value, onChange }: TotpCodeInputProps) {
  return (
    <div>
      <label htmlFor="totpCode" className="block text-sm font-medium text-foreground mb-2">
        確認コード
      </label>
      <input
        id="totpCode"
        type="text"
        inputMode="numeric"
        autoComplete="one-time-code"
        pattern="[0-9]{6}"
        maxLength={TOTP_CODE_LENGTH}
        value={value}
        onChange={(e) => onChange(e.target.value.replace(/\D/g, '').slice(0, TOTP_CODE_LENGTH))}
        required
        className="w-full px-4 py-3 bg-muted/50 border border-input rounded-lg text-foreground text-center text-xl tracking-[0.5em] tabular-nums placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
        placeholder="000000"
      />
    </div>
  );
}
